import { render, staticRenderFns } from "./UnRegisteredPanel.vue?vue&type=template&id=ed1b0ab8&scoped=true"
import script from "./UnRegisteredPanel.vue?vue&type=script&lang=js"
export * from "./UnRegisteredPanel.vue?vue&type=script&lang=js"
import style0 from "./UnRegisteredPanel.vue?vue&type=style&index=0&id=ed1b0ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1b0ab8",
  null
  
)

export default component.exports